const FrontPage = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='FrontPage--Riddle__Screen__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='FrontPage--Riddle__Screen__Background__Image' />
                )} */}

                <img src='/img/games/riddle/female/september-11-2026/background.png' className='FrontPage--Riddle__Screen__Background__Image' />
            </div>

            <div className="FrontPage--Riddle__Screen__Container">
                {/* <img src='/img/page/adsl-five.png' className='FrontPage--Riddle__Screen__Container__Logo' style={{ maxWidth: '500px' }} /> */}
                <img src="/img/games/riddle/female/september-11-2026/Logo-optimo-blanco-768x320.png"  className='FrontPage--Riddle__Screen__Container__Logo' style={{ maxWidth: '500px', marginBottom: '0' }} />
                
                <p style={{ fontFamily: '"GFS Didot", serif', fontSize: '3em', textAlign: 'center', marginTop: '0', marginBottom: '1em' }}>PRESENTA</p>

                <p className="FrontPage--Riddle__Screen__Container__Title" style={{ fontFamily: '"GFS Didot", serif' }}>ADIVINA ADIVINADOR</p>
                {/* <div style={{ textAlign: 'center', marginTop: '2em' }}>
                    <img src="/img/games/riddle/male/july-17-2026/lucho.png" style={{ width: '350px' }} />
                    <img src="/img/games/riddle/male/july-17-2026/tunita.png" style={{ width: '350px' }} />
                </div> */}
                {/* <img src="/img/games/riddle/female/january-24-2026/provi-logotipo.png" className="FrontPage--Riddle__Screen__Container__BrandLogo" /> */}
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { FrontPage };